import React from "react";
import { ArticleCard } from "./ArticleCard";

export const ArticleList = ({ articles, currentUserId, editable = false }) => {
  return (
    <div className="article-list">
      {articles.map((a) => {
        return <ArticleCard key={a.id} editable={editable} article={a} />;
      })}
    </div>
  );
};
